module.exports = __webpack_public_path__ + "static/media/page_divider_gray.c749a485.svg";